import { TablePagination } from "@/components/primitives/TablePagination"
import { useReactTable } from "@tanstack/react-table"

interface ReportPaginationProps {
	table: ReturnType<typeof useReactTable<any>>
}

export function ReportPagination({ table }: ReportPaginationProps) {
	return (
		<TablePagination
			className="mt-2.5"
			currentPage={table.getState().pagination.pageIndex + 1}
			pageCount={table.getPageCount()}
			onFirstPage={() => table.setPageIndex(0)}
			onPreviousPage={() => table.previousPage()}
			onNextPage={() => table.nextPage()}
			onLastPage={() => table.setPageIndex(table.getPageCount() - 1)}
			canPreviousPage={table.getCanPreviousPage()}
			canNextPage={table.getCanNextPage()}
		/>
	)
}
